/** Minimal shape a document needs to be delta-synced into a timeline list. */
export type SyncableDocument = {
  _id: string;
  timestamp: Date;
};

/**
 * Merge changed documents into an existing list and drop removed ones.
 * Changed documents replace existing ones with the same `_id`.
 * Returns a new array sorted by `timestamp` descending; inputs are not mutated.
 */
export function applyDocumentChanges<T extends SyncableDocument>(
  existing: readonly T[],
  changed: readonly T[],
  removedIds: readonly string[] = [],
): T[] {
  if (changed.length === 0 && removedIds.length === 0) return [...existing];

  const byId = new Map(existing.map((doc) => [doc._id, doc]));
  for (const id of removedIds) byId.delete(id);
  for (const doc of changed) byId.set(doc._id, doc);

  return [...byId.values()].sort(
    (a, b) => b.timestamp.getTime() - a.timestamp.getTime(),
  );
}
